import {useEffect, useState} from 'react';
import cn from 'classnames';
import {EmblaCarouselType} from 'embla-carousel';
import Autoplay from 'embla-carousel-autoplay';
import useEmblaCarousel from 'embla-carousel-react';

import {openLandingUrl} from '@zzng/common/utils/openLandingUrl';

import {HomeRes} from '@/root/models/home';

import Swiper from '@/shared/components/Swiper';
import {TIARA_ACTION, TIARA_PAGE_NAME} from '@/shared/constants/tiara';
import useTiara from '@/shared/hooks/useTiara';

type Props = {
  banners: HomeRes['banners'];
};

const Banners = ({banners}: Props) => {
  const canSnap = banners.length > 1;

  const [currentIndex, setCurrentIndex] = useState(0);
  const [emblaRef, emblaApi] = useEmblaCarousel({loop: true, active: canSnap}, [
    // eslint-disable-next-line new-cap
    Autoplay({
      delay: 5000,
      stopOnInteraction: false,
      stopOnFocusIn: false
    })
  ]);
  const {trackEvent} = useTiara({pageName: TIARA_PAGE_NAME.HOME});

  const onClickBanner = (landingUrl: string, label: string) => {
    trackEvent({action: TIARA_ACTION.BANNER_CLICK, customProps: {title: label}});
    openLandingUrl(landingUrl);
  };

  const onSelect = (emblaApi: EmblaCarouselType) => {
    setCurrentIndex(emblaApi.selectedScrollSnap());
  };

  useEffect(() => {
    if (!emblaApi) return;
    emblaApi.on('reInit', onSelect);
    emblaApi.on('select', onSelect);
  }, [emblaApi]);

  if (!banners.length) return null;

  return (
    <div className="slide_g">
      <div className="group_slide">
        <Swiper
          emblaRef={emblaRef}
          slides={banners.map(({landingUrl, imageUrl, label, backgroundColor}, index) => (
            <div
              className="item_slide"
              key={index}
              style={{backgroundColor}}
              onClick={() => onClickBanner(landingUrl, label)}
            >
              <button type="button" className="btn_slide">
                <img src={imageUrl} alt={label} className="img_slide" />
                <span className="screen_out">새창열림</span>
              </button>
            </div>
          ))}
        />
      </div>
      {canSnap && (
        <div className="control_slide">
          {banners.map((_, index) => (
            <span className={cn('dot_slide', {on: index === currentIndex})} key={index}></span>
          ))}
        </div>
      )}
    </div>
  );
};

export default Banners;
